// src/app/core/constants/api-endpoints.ts
export const API_ENDPOINTS = {
  optmeout: {
    optout: () => `opt-me-out/`,
  },
  optmein: {
    optin: () => `dnq-opt-in/`,
  },
  mecself: {
    selfEnroll: () => `self-mec-enroll/`,
  },
  serviceself: {
    selfEnroll: () => `service-self-enroll/`,
  },
  verifyToken: {
    public: (token: string) => `verify-public-token/${token}`,
  },
  download: {
    download: (token: string) => `download-payroll/${token}`,
  },
  auth: {
    login: 'login',
    forgotPassword: 'forgot-password',
    resetpassword: 'reset-password',
    changePassword: 'change-password',
    refreshToken: 'refresh-token',
    switchOrganization: (organizationId: number) => `switch-organization/${organizationId}`,
  },
  employer: {
    list: 'employers',
    create: 'create-employer',
    update: 'update-employer',
    updateStatus: 'employer/update-status',
    details: (id: string) => `employer/${id}`,
    adminFeeForMonth: (id: number, month: number, year: number) => `employer/${id}/admin-fee?month=${month}&year=${year}`,
    employerContacts : (id : number) => `employer/contacts?employer_id=${id}`,
    employerContactsCreate : "employer/contact/create",
    employerContactsUpdate : "employer/contact/update",
    employerContactsDelete : "employer/contact/delete",
    agents: 'employer/agents',
    commissions: 'employer/agent/commissions',
    attachAgent: 'employer/attach-agent',
    removeAgent: 'employer/remove-agent',
    notes: 'employer/notes',
    dropdown: 'employers/minimal',
    delete: 'delete-employer',
    parentminimal: 'employers/parentminimal',
    planminimal: 'plans/minimal',
    parent_dropdown: 'employers/parentminimal',
    employerAgents: (id: string) => `attach-agent?employer_id=${id}`,
    employerAgent: (employer_id: string, agent_id: string) =>
      `employer-agent?employer_id=${employer_id}&agent_id=${agent_id}`,
    // Plans
    attachPlan: 'employer/attach-plan',
    employerPlan: (employer_id: string, plan_id: string) =>
      `employer-plan?employer_id=${employer_id}&plan_id=${plan_id}`,
    employerPlans: (id: string) => `attach-plan?employer_id=${id}`,
    removePlan: 'employer/remove-plan',
    plans_dropdown: (id: string) => `/employer/plansminimal?employer_id=${id}`,
    update_primaryAgent: '/update-primary-agent',
    syncAgents: (employer_id: string) => `sync-agents/${employer_id}`,
    profileReport: 'employer-profile-report',
    bankAccounts: (id: string) => `employer/${id}/bank-accounts`,
    bankAccount: (id: string | number) => `bank-accounts/${id}`,
    components: (id: string) => `employer/${id}/components`,
    componentDetail: (id: string, code: string) => `employer/${id}/components/${code}`,
    serviceComponents: (id: string, service: string) => `employer/${id}/services/${service}/components`,
    componentConfigurations: (id: string, code: string) => `employer/${id}/components/${code}/configurations`,
    componentTemplates: (id: string, code: string) => `employer/${id}/components/${code}/templates`,
    availableTemplates: (id: string, code: string) => `employer/${id}/components/${code}/templates/available`,
    componentTemplateEmails: (id: string, code: string) => `employer/${id}/components/${code}/templates/emails`,
    componentTemplate: (id: string, code: string, templateId: string | number) => `employer/${id}/components/${code}/templates/${templateId}`,
    componentConfiguration: (id: string | number) => `component-configurations/${id}`,
    availableComponents: (id: string) => `employer/${id}/components/available`,
    linkComponents: (id: string) => `employer/${id}/components/link`,
    syncComponents:(employer_id: number) => `sync-components/${employer_id}`,
  },
  vendor: {
    list: 'vendors-listing',
    create : 'vendors/create',
    delete : 'vendors/delete',
    single : (id: string | number) => `vendors/single/${id}`,
    bankAccounts: (id: string | number) => `vendors/bank-accounts/${id}`,
    vendorListingByComponentId: (id: null | number) => `vendors-listing/component/${id}`,
    updateBankAccounts: (id: string | number) => `vendor-bank-accounts/${id}`,
    component : {
      list : 'vendors-component/listing',
      create : `vendors-component/create`,
      remove : `vendors-component/remove`,
      single : (id: string | number) => `vendors-component/${id}`,
    }
  },
  employees: {
    list: 'employees',
    create: 'create-employees',
    add: 'add',
    update: 'update-employees',
    employerLinkedAgents : 'employer-agents',
    attachAgent : 'attach-agent',
    details: (id: string) => `employee/${id}`,
    delete: 'delete-employees',
    dropdown: 'employees/minimal',
    blockCommunication: (id: string,condition:string) => `block-communication/${id}/${condition}`,
    optoutEmployers: (id: string) => `optout-employee/${id}`,
    terminateEmployee: (id: string) => `terminate-employee/${id}`,
    disqualifyEmployee: (id: string) => `disqualify-employee/${id}`,
    employers: (id: string) => `employees-employers?id=${id}`,
    downloadExcel: 'employees-download',
    mec: 'mec-employees',
    excelMEC: 'mec-employees-download',
    eligibleEmployees: (employerid: number) => `mec-eligible-download/${employerid}`,
    importMEC: 'import-mec-employees',
    sampleMEC: 'mec-sample-download',
    serviceEnrollmentSample: 'service-enrollment-sample-download',
    serviceEligibleEmployees: (employerid: number) => `service-eligible-download/${employerid}`,
    importServiceEnrollments: 'import-service-enrollments',
    enrollments: 'service-enrollments',
    enrollmentsDownload: 'service-enrollment-download',
  },
  agent: {
    list: 'agents',
    create: 'create-user',
    update: 'update-user',
    delete: 'delete-user',
    dropdown: 'agents/minimal',
    details: (id: string) => `/agent/${id}`,
    employers: (id: string) => `agent-employers?id=${id}`,
    emailTenants: 'emailTenants/minimal',
  },
  admin: {
    list: 'users',
    create: 'create-user',
    update: 'update-user',
    delete: 'delete-user',
    details: (id: string) => `user/${id}`,
    minimal: 'admin/minimal',
    checkbox: 'organizations/minimal',
  },
  components: {
    minimal: 'components/minimal',
  },
  user: {
    profile: 'profile',
    changePassword: 'profile-change-password',
    updateProfile: 'profile',
  },
  actuals: {
    list: 'payrolls',
    add: 'add',
    createPayroll: 'create-payroll',
    updatePayroll: 'update-payroll',
    confirmPayroll: (id: string) => `confirm-payroll/${id}`,
    downloadPayroll: (id: string) => `download-actual-payroll/${id}`,
    details: (id: string) => `payroll/${id}`,
    deletePayroll: (id: string) => `payroll/${id}`,
    downloadTemplate: 'download-template-payroll',
    // Pending on BE: returns every entry of a payroll for the reverse preview
    payrollEntries: (id: string) => `payroll/${id}/entries`,
    reversePayroll: 'reverse-payroll',
  },
  census: {
    list: 'census',
    add: 'add',
    createcensus: 'census',
    updatecensus: 'census-update',
    runAnalysis: (id: string) => `analyze-census/${id}`,
    confirmcensus: (id: string) => `confirm-census/${id}`,
    details: (id: string) => `census/${id}`,
    downloadcensus: (id: string) => `download-uploaded-census/${id}`,
    downloadFile: (condition: string, id: string, fileId?: string) => `download-analyzed-files/${condition}/${id}/${fileId ? fileId + '/' : ''}`,
    downloadSample: `download-census-sample`,
    archiveCensus: (id: string) => `archive-census/${id}`,
    fileDetails: (id: string) => `census-file-details/${id}`,
    updateBatchStatus: 'update-batch-status',
  },
  boarding: {
    list: 'onboardings',
    add: 'add',
    createboarding: 'create-boarding',
    updateboarding: 'update-boarding',
    templates: 'templates',
    sendCommunication: `send-communication`,
    sendAllCommunication: `send-all-communication`,
    getCommunication: (step: string, batchCode: string) => `communication/${step}/${batchCode}`,
    getTemplateByEmployer: (legacyId: string, employerid: number) => `templates/${legacyId}/${employerid}`,
    getSMSTemplateByEmployer: (legacyId: string, employerid: number) => `templates/sms/${legacyId}/${employerid}`,
    sendContract: (id: string) => `send-contract/${id}`,
    downloadEnrollmentFile: (id: string,date:string) => `download-enrolled-employee/${id}/${date}`,
    markContractSign: (id: string) => `contract-signed/${id}`,
    markEnrolled: (id: string) => `enrolled-employee/${id}`,
    confirmboarding: (id: string) => `confirm-boarding/${id}`,
    details: (id: string) => `census/${id}`,
    downloadboarding: (id: string) => `download-uploaded-boarding/${id}`,
    updateOptoutDate: (id: string, date: string) => `change-optout-date/${id}/${date}`,
    archiveBoarding: (id: string) => `archive-boarding/${id}`,
  },
  optout: {
    base: "optout",
    list: "optouts",
    details: "details",
    add: "bulk-optout",
    edit: "edit", 
    download: "download-optouts", 
    detailsWithId: (id: string) => `optout/${id}`,
  },
  reports: {
    base: "reports",
    list: "list",
    commission_report: "commissions-report",
    invoice_report: "invoice-report",
    payroll_anomaly_report: "payroll-anomaly-report",
    mec_payable_report: "mec-payable-report",
    mec_enrollments_file: "mec-enrollment-download",
    mec_remittance_report: "mec-remittance-report",
    service_payable_report: "service-payable-report",
    service_enrollments_file: "service-enrollment-download",
    service_remittance_report: "service-remittance-report",
  },
  commissions: {
    adminEmployerCommission: 'v1/agent-employers-commissions',
    adminSubEmployerCommission: 'v1/agent-subemployers-commissions/',
    adminEmployeeCommission: 'v1/employee-commissions/',
    list: 'v1/all_commissions',
    add: 'add',
    agentCommission: 'agent-employers-commissions',
    subemployersPlanCommissions: 'v1/agent-subemployers-plan-commissions',
    employerMinimal: 'v1/commission/employers-minimal',
    subEmployerMinimal: 'v1/commission/subemployers-minimal',
    employeeMinimal: 'v1/commission/employees-minimal',
    planMinimal: 'v1/commission/plans-minimal',
  },
  learnMore: {
    base: 'learn-more',
    single:`single-communication-details`
  },
  plans: 'plans',
};
